"use strict";
/**
 *
 * https://dev.to/paulriviera/add-azure-application-insights-to-a-static-nextjs-app-921
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeverityLevel = void 0;
const applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (exports.SeverityLevel = SeverityLevel = {}));
class ApplicationInsightsManager {
    constructor(cloudRoleName, connectionString, enableUnhandledPromiseRejectionTracking = true, enableAutoRouteTracking = true, extensions = []) {
        this.cloudRoleName = cloudRoleName;
        this.connectionString = connectionString;
        this.enableUnhandledPromiseRejectionTracking = enableUnhandledPromiseRejectionTracking;
        this.enableAutoRouteTracking = enableAutoRouteTracking;
        this.extensions = extensions;
        this.getHref = () => {
            if (typeof window !== 'undefined') {
                return window.location.href;
            }
            return '';
        };
        this.ai = this.intialize();
    }
    intialize() {
        const ai = new applicationinsights_web_1.ApplicationInsights({
            config: {
                connectionString: this.connectionString,
                enableUnhandledPromiseRejectionTracking: this.enableUnhandledPromiseRejectionTracking,
                enableAutoRouteTracking: this.enableAutoRouteTracking,
                extensions: this.extensions,
            },
        });
        ai.loadAppInsights();
        // eslint-disable-next-line
        const telemetryInitializer = (envelope) => {
            // eslint-disable-next-line
            envelope.tags['ai.cloud.role'] = this.cloudRoleName;
        };
        ai.addTelemetryInitializer(telemetryInitializer);
        return ai;
    }
    trackError({ message, properties, severityLevel }) {
        this.ai.trackException({ exception: new Error(message), severityLevel }, Object.assign(Object.assign({}, properties), { page: this.getHref() }));
    }
    trackMetric({ name, average }) {
        this.ai.trackMetric({ name, average });
    }
    trackTrace({ message, properties, severityLevel }) {
        this.ai.trackTrace({ message, severityLevel }, Object.assign(Object.assign({}, properties), { page: this.getHref() }));
    }
}
exports.default = ApplicationInsightsManager;
